exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product a.edit-link{position:absolute;top:5px;right:30px;padding:10px 15px;z-index:3}a.edit-link svg{width:17px}.product a.edit-link svg path{fill:#999;-webkit-transition:fill .3s ease;-moz-transition:.3s ease fill;transition:fill .3s ease}.product a.edit-link:hover svg path{fill:#1e824c!important}", ""]);

// exports
